import { render, staticRenderFns } from "./CallsChartInfo.vue?vue&type=template&id=d63e574e&scoped=true"
import script from "./CallsChartInfo.vue?vue&type=script&lang=js"
export * from "./CallsChartInfo.vue?vue&type=script&lang=js"
import style0 from "./CallsChartInfo.vue?vue&type=style&index=0&id=d63e574e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63e574e",
  null
  
)

export default component.exports